export class OffersNavigationConstants {
    public static readonly Product_Unknown = 'unknown';
    public static readonly Promohub = 'promo hub';
    public static readonly BackButtonClick = 'Back button - Click';
    public static readonly Navigation = 'navigation';
    public static readonly Back = 'back';
}
